import * as Yup from 'yup';

const groupOption = Yup.object().shape({
  value: Yup.string().nullable(),
  label: Yup.string().nullable(),
});

const intercomItem = Yup.object().shape({
  Number: Yup.string()
    .nullable()
    .test('phone-format', 'intercomNumberIsInvalid', (value) => {
      // allow empty / null values (optional field)
      if (value === null || value === undefined || String(value).trim() === '') return true;
      const v = String(value).trim();
      const re = /^\+?\d+\/1$/;
      return re.test(v);
    }),
});

const manageServiceSchema = Yup.object().shape({
  groupsAndPermissions: Yup.array().of(groupOption).nullable(),
  rfIdTagOne: Yup.string().nullable(),
  rfIdTagTwo: Yup.string().nullable(),
  phoneNumbers: Yup.array().of(intercomItem).nullable(),
});

export default manageServiceSchema;

